<template lang="pug">
  .section-layout
    .content-layout-list
      .section-filter
        .nav-back-btn(@click="goBack")
        .field-group.is-horizontal
          .field
            label.label 起止时间
            .field.is-horizontal
              date-picker.w-140(style="width: 260px;", type="range", placeholder="请选择起止时间", v-model="filter_data.range_time")
          .field
            a.button.primary(@click="search") 搜索
          .field
            a.button(@click="reset") 重置
        .time
          .day(:class="date_type === 1 ? 'active' : ''", @click="today") 今日
          .month(:class="date_type === 2 ? 'active' : ''", @click="thisMonth") 本月
      .revenue.top-total
        div
          h2.m-b-20 页面访问统计
            el-popover.tips-text(placement="top-start", width="300", trigger="hover")
              .tips_page
                p 页面访问人数：统计访问活动页面的去重用户数；
                p 页面访问次数：统计访问活动页面的总次数；
                p 页面跳转人数：统计在活动页面跳转到二级页面的去重用户数；
                p 页面跳转次数：统计在活动页面跳转到二级页面的总次数。
              .el-icon-question(slot="reference")
          div.income
            div.statistics.no-border
              div.title 页面访问人数
              div.price {{data.visitor_count}}
            div.statistics
              div.title 页面访问次数
              div.price {{data.visit_count}}
            div.statistics
              div.title 报名人数
              div.price {{data.sign_up_count}}
      //- .revenue.top-total
      //-   div
      //-     h2.m-b-20 订单转化统计
      //-       el-popover.tips-text(placement="top-start", width="300", trigger="hover")
      //-         .tips_order
      //-           p 订单转化统计，只包含活动页面关联的商品/服务/养护卡的订单。
      //-           p 下单人数：统计活动关联商品/服务/养护卡的下单用户数（去重）；
      //-           p 订单数：统计活动关联商品/服务/养护卡的下单笔数；
      //-           p 活动关联商品总金额：统计活动关联商品/服务/养护卡的商品总金额。
      //-         .el-icon-question(slot="reference")
      //-     div.income
      //-       div.statistics.no-border(style="width: 50%;")
      //-         div.title 下单人数
      //-         div.price {{data.order_customer_count}}
      //-       div.statistics(style="width: 50%;")
      //-         div.title 订单数
      //-         div.price {{data.order_count}}
            //- div.statistics
            //-   div.title 活动关联商品总金额
            //-   div.price ¥ {{data.order_amount}}
      .revenue.top-total
        div
          h2.m-b-20 好友助力统计
            el-popover.tips-text(placement="top-start", width="300", trigger="hover")
              .tips_page
                p 发起助力人数：统计发起助力活动的总人数；
                p 参与助力人数：统计参与助力活动的总人数；
                p 成功助力数量：统计助力活动成功的总数量；
                p 拉新数量：统计助力活动产生的新注册用户数量；
              .el-icon-question(slot="reference")
          div.income
            div.statistics.no-border
              div.title 发起助力人数
              div.price {{data.help_launch_count}}
            div.statistics
              div.title 参与助力人数
              div.price {{data.help_join_count}}
            div.statistics
              div.title 成功助力数量
              div.price {{data.help_success_count}}
            div.statistics
              div.title 拉新数量
              div.price {{data.help_new_user_count}}
      .revenue.top-total
        div
          h2.m-b-20 优惠券数据
            el-popover.tips-text(placement="top-start", width="300", trigger="hover")
              .tips_page
                p 获券数量：用户通过活动报名获取的优惠券数量；
                p 用券数量：用户通过活动报名获取的优惠券，其中使用优惠券的数量；
                p 用券金额：用户通过活动报名获取的优惠券，其中使用优惠券抵扣的金额；
                p 订单金额：用户使用优惠券的订单，产生的订单实收金额；
              .el-icon-question(slot="reference")
          div.income
            div.statistics.no-border(style="width: 50%;")
              div.title 获券数量
              div.price {{data.coupon_stat.count}}
            div.statistics(style="width: 50%;")
              div.title 用券数量
              div.price {{data.coupon_stat.count_used}}
            //- div.statistics
            //-   div.title 用券金额
            //-   div.price ¥ {{data.coupon_stat.amount_used}}
            //- div.statistics
            //-   div.title 订单实收金额
            //-   div.price ¥ {{data.coupon_stat.amount_ordered}}
      .revenue.top-total
        div
          .head-content
            h2.m-b-20 渠道数据
              el-popover.tips-text(placement="top-start", width="300", trigger="hover")
                .tips_page
                  p 海报扫码人数：通过活动海报形式，进入小程序活动的去重用户数量；
                  p 海报扫码次数：通过活动海报形式，进入小程序活动的用户次数；
                  p 海报报名人数：通过活动海报形式，完成活动报名的去重用户数量；
                  p 轮播图点击人数：点击小程序活动轮播图的去重用户数量；
                  p 轮播图点击次数：点击小程序活动轮播图形式的总次数；
                  p 轮播图报名人数：通过小程序轮播图形式，进入活动并完成活动报名的去重用户数量；
                .el-icon-question(slot="reference")
            a.operation-link(@click="viewEmployeeData") 查看员工数据 >
          div.income
            div.statistics.no-border
              div.title 海报扫码人数
              div.price {{data.access_stat.poster.visitor_count}}
            div.statistics
              div.title 海报扫码次数
              div.price {{data.access_stat.poster.visit_count}}
            div.statistics
              div.title 海报报名人数
              div.price {{data.access_stat.poster.sign_up_count}}
          div.income
            div.statistics.no-border
              div.title 轮播图点击人数
              div.price {{data.access_stat.carousel.visitor_count}}
            div.statistics
              div.title 轮播图点击次数
              div.price {{data.access_stat.carousel.visit_count}}
            div.statistics
              div.title 轮播图报名人数
              div.price {{data.access_stat.carousel.sign_up_count}}
  
</template>

<script>
import Api from '@/mixins/modules/Content'
import DatePicker from '@/components/generics/form/DatePicker'
export default {
  mixins: [Api],
  name: 'ContentStatisticTemplate',
  components: {
    DatePicker,
  },
  data () {
    return {
      activity_id: '', // 活动id
      date_type: '', // 0选择时间，1今日，2本月,
      // 日期组件
      filter_data: {
        range_time: '',
        start_time: '',
        end_time: '',
      },
      data: {
        visitor_count: '', // 页面访问人数
        visit_count: '', // 页面访问次数
        sign_up_count: '', // 报名人数
        order_customer_count: '', // 下单人数
        order_count: '', // 订单数
        order_amount: '', // 活动关联商品总金额
        help_launch_count: '', // 发起助力人数
        help_join_count: '', // 参与助力人数
        help_success_count: '', // 成功助力数量
        help_new_user_count: '', // 拉新数量
        // 优惠券数据
        coupon_stat: {
          count: '', // 获券数量
          count_used: '', // 用券数量
          amount_used: '', // 用券金额
          amount_ordered: '', // 订单实收金额
        },
        // 渠道数据
        access_stat: {
          // 海报相关统计
          poster: {
            visitor_count: '', // 海报扫码人数
            visit_count: '', // 海报扫码次数
            sign_up_count: '', // 海报报名人数
          },
          // 轮播图相关统计
          carousel: {
            visitor_count: '', // 轮播图点击人数
            visit_count: '', // 轮播图点击次数
            sign_up_count: '', // 轮播图报名人数
          },
        },
      },
    }
  },
  methods: {
    // 返回
    goBack () {
      this.$router.push({
        name: 'contentList',
        query: {
          // save: 1,
        },
      })
    },

    // 今日
    today () {
      if (this.date_type === 1 || this.date_type === 0) return // 如果已经是今日或搜索状态不请求接口
      const year = new Date().getFullYear()
      const month = new Date().getMonth()
      const day = new Date().getDate()
      const startTime = new Date(year, month, day)
      const endTime = new Date(year, month, day, 23, 59, 59)
      this.filter_data.start_time = startTime / 1000
      this.filter_data.end_time = endTime / 1000
      this.date_type = 1
      this.filter_data.range_time = ''
      this.getActivityStatisticTemplate()
    },

    // 本月
    thisMonth () {
      if (this.date_type === 2 || this.date_type === 0) return // 如果已经是本月或搜索状态不请求接口
      const year = new Date().getFullYear()
      const month = new Date().getMonth()
      const lastDay = new Date(new Date(year, month + 1, 1) - 1).getDate()
      const startTime = new Date(year, month) / 1000
      const endTime = new Date(year, month, lastDay, 23, 59, 59) / 1000
      this.filter_data.start_time = startTime
      this.filter_data.end_time = endTime
      this.date_type = 2
      this.filter_data.range_time = ''
      this.getActivityStatisticTemplate()
    },

    // 搜索
    search () {
      this.date_type = 0
      if (this.filter_data.range_time === '') {
        this.filter_data.start_time = ''
        this.filter_data.end_time = ''
      }
      this.getActivityStatisticTemplate()
    },

    // 重置
    reset () {
      this.date_type = ''
      this.today()
    },

    // 查看员工数据
    viewEmployeeData () {
      this.$router.push({
        name: 'employeeData',
        query: {
          id: this.activity_id,
          range_time: this.date_type === 0 ? this.filter_data.range_time : '',
          start_time: this.date_type === 0 ? this.filter_data.start_time : '',
          end_time: this.date_type === 0 ? this.filter_data.end_time : '',
          date_type: this.date_type,
        },
      })
    },

    // 模板活动数据统计（模板活动）
    async getActivityStatisticTemplate () {
      try {
        const { response, result } = await this.GetActivityStatisticTemplateApi({
          activity_id: this.activity_id,
          start_time: this.filter_data.start_time,
          end_time: this.filter_data.end_time,
        })
        if (response.status === 200 && result.code === 0) {
          this.data = result.data
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取模板活动数据统计失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取模板活动数据统计失败',
          content: `错误：${err}`,
        })
      }
    },
  },

  watch: {
    'filter_data.range_time': function (newVal) {
      if (newVal !== '') {
        let start, end
        let date = newVal.split(' 至 ');
        [start, end] = [date[0].split('-'), date[1].split('-')]
        start[1] = --start[1]
        end[1] = --end[1]
        // 存储选择日期的时间戳（秒）
        this.filter_data.start_time = new Date(...start).getTime() / 1000
        this.filter_data.end_time = new Date(...end, 23, 59, 59).getTime() / 1000
      } else {
        if (this.date_type === 1 || this.date_type === 2) return // 如果时间是被today或thisMonth方法更改的不重置查询时间
        this.filter_data.start_time = ''
        this.filter_data.end_time = ''
      }
    },
  },
  mounted () {
    this.activity_id = this.$route.query.id
    this.today()
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/mixins'
.section-layout
  height calc(100% - 56px)
.section-filter
  padding-left 70px
.nav-back-btn
  position absolute
  top 36px
  left 16px
  width 32px
  height 32px
  border-radius 100%
  background #CED3DC center no-repeat url('~@/assets/back.svg')
  background-size 16px
  box-shadow 0 2px 6px 0 rgba(0, 0, 0, 0.08)
  cursor pointer
  z-index 2
.content-layout-list
  min-height calc(100% - 346px)
  overflow-y auto
.title-filter
  padding 25px 65px 10px
  background #e8e9eb
.field-group
  position relative
.time
  position absolute
  right 40px
  bottom 20px
  border-radius 3px
  border 1px solid #D9D9D9
  box-sizing border-box
.time .day, .time .month
  display inline-block
  width 78px
  height 28px
  line-height 28px
  text-align center
  font-size 14px
  border-radius 3px
  background #D9D9D9
  color #9A9B9A
  cursor pointer
.active
  color #121212 !important
  background #FFFFFF !important
.revenue
  padding-top 0px
  box-sizing border-box
.top-total
  overflow unset !important
  background #e8e9eb !important
  padding 10px 30px 0 !important
.top-total:last-of-type
  padding-bottom 30px !important
.m-b-20
  margin-bottom 20px
.income
  background #ffffff
  height 100px
  display flex
  justify-content flex-start
  align-items center
.statistics
  width 33%
  text-align left
  padding-left 30px
  border-left 1px solid #D9D9D9
  box-sizing border-box
  .title
    font-size 16px
    color #999999
    font-weight 500
  .price
    margin-top 10px
    font-size 30px
    color #404040
    font-weight 500
.no-border
  border none !important
.head-content
  display flex
  justify-content space-between
</style>


// WEBPACK FOOTER //
// src/components/content/ContentStatisticTemplate.vue